import { render, staticRenderFns } from "./Downline.vue?vue&type=template&id=6489ab74&scoped=true&"
import script from "./Downline.vue?vue&type=script&lang=ts&"
export * from "./Downline.vue?vue&type=script&lang=ts&"
import style0 from "./Downline.vue?vue&type=style&index=0&id=6489ab74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489ab74",
  null
  
)

export default component.exports